import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  adviserList,
  adviserDelete,
} from "../../../../store/actions/memberActions";
import { Popconfirm, message, Empty } from "antd";
import { MaskEmail } from "../../../../utils/helper";
import TableWrapper from "../../../../components/Tables";
import Pagination from "../../../../components/Pagination";

const AdviserIndex = () => {
  const [search, setsearch] = useState("");
  let dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    dispatch(adviserList(1, search));
    localStorage.removeItem("id_adviser");
  }, [dispatch]);

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("adviser-read")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);

  const dataadviserList = useSelector((state) => state.adviserList);
  const { adviser, listsAdviser } = dataadviserList;

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  const handleEdit = (id) => {
    localStorage.setItem("id_adviser", id);
    history.push("/adviser-edit");
  };

  const tableHead = [
    { name: "No" },
    { name: "ID Agent" },
    { name: "Name" },
    { name: "Office" },
    { name: "Email" },
    { name: "Join Date" },
    { name: "Status" },
    { name: "Action" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.id_agent },
    { render: (item) => item.name },
    { render: (item) => item.office },
    { render: (item) => <MaskEmail item={item} /> },
    { render: (item) => item.join_date },
    { render: (item) => (
      <div className={`badge badge-${item.active === 3 ? 'danger' : item.active === 1 ? 'success' : 'danger'}`}>
        {( item.active === 3 ? 'Blacklist' : item.active === 1 ? 'active' : 'deactive' )}
      </div>
    ) },
    {
      render: (item) => (
        <div align="center">
          {userInfo.permission.find((e) => e === "adviser-edit") ? (
            <button
              onClick={() => handleEdit(item.id)}
              className="btn btn-warning btn-sm"
            >
              <i className="fa fa-pencil"></i> Edit{" "}
            </button>
          ) : null}
          {userInfo.permission.find((e) => e === "adviser-delete") ? (
            <Popconfirm
              title="Are you sure to delete this parent?"
              onConfirm={() =>
                dispatch(adviserDelete(item.id)).then(() =>
                  dispatch(adviserList(1, search))
                )
              }
              onCancel={() => message.info("Canceled!")}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-danger btn-sm">
                <i className="fa fa-trash-o"></i> Delete{" "}
              </button>
            </Popconfirm>
          ) : null}
        </div>
      ),
    },
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(adviserList(1, search));
  };

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Adviser</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  {userInfo.permission.find((e) => e === "adviser-create") ? (
                    <Link
                      to={"/adviser-create"}
                      className="btn btn-info btn-sm"
                    >
                      Create
                    </Link>
                  ) : null}
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name or ID Agent"
                    style={{ float: "right", width: "50%", textOverflow: "ellipsis", paddingRight: "33px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper
                tableHead={tableHead}
                tableBody={tableBody}
                datas={listsAdviser}
              />
              <Pagination
              datas={adviser}
              listsData={adviserList}
              search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdviserIndex;
